import { useTranslation } from "react-i18next";
import { Zap, Shield, Users, TrendingUp } from "lucide-react";

const Features = () => {
  const { t } = useTranslation();
  const features = [
    { icon: Zap, title: t("features.items.fastResults"), desc: t("features.items.fastResultsDesc") },
    { icon: Shield, title: t("features.items.guarantee"), desc: t("features.items.guaranteeDesc") },
    { icon: Users, title: t("features.items.community"), desc: t("features.items.communityDesc") },
    { icon: TrendingUp, title: t("features.items.support"), desc: t("features.items.supportDesc") },
  ];

  return (
    <section id="porque" data-testid="features-section" className="py-24 md:py-32 border-b border-zinc-200 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16">
          <div className="md:col-span-5">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#4F46E5] mb-4">{t("features.tag")}</p>
            <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              {t("features.title1")}
              <br />
              {t("features.title2")}
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-center">
            <p className="text-lg text-zinc-700 leading-relaxed">{t("features.intro")}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-200">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div key={f.title} data-testid={`feature-${i}`} className="bg-white p-8 md:p-10 hover:bg-zinc-900 hover:text-white group transition-colors duration-300">
                <Icon className="w-8 h-8 text-[#4F46E5] group-hover:text-white mb-6" strokeWidth={1.5} />
                <h3 className="font-display font-bold text-xl mb-3">{f.title}</h3>
                <p className="text-sm text-zinc-600 group-hover:text-zinc-300 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
